document.addEventListener('DOMContentLoaded', function() {
  // Find all sample order forms
  const sampleForms = document.querySelectorAll('.sample-order-container form');
  
  sampleForms.forEach(function(form) {
    form.addEventListener('submit', function() {
      // Get the button
      const button = this.querySelector('.sample-order-button');
      
      // Disable button to prevent multiple submissions
      if (button) {
        button.disabled = true;
        
        // Add loading class
        button.classList.add('loading');
        
        // Update button text
        const buttonText = button.querySelector('.btn-text');
        if (buttonText) {
          buttonText.textContent = 'Adding Sample...';
        }
      }
    });
  });
});